// extracted by mini-css-extract-plugin
export default {"container":"HeaderOnlyLayout_container__tdNus"};